module.exports = __webpack_public_path__ + "static/teamwork-b3e22cc6ef1a6b66f5ff6ed0bb0135ae.svg";